import request from "../../request";

export default {
    state(){
        return {
            products:[],
            totalSale:[],
            totalBuy:[]
        }
    },
    getters:{
        getTotalSale(state){
            return state.totalSale
        },
        getTotalBuy(state){
            return state.totalBuy
        }
    },
    actions:{
        getClientProducts({state},payload){
            const {id,...pyld}=payload
            return request.get('/clients/products/'+id,{params:{...pyld}}).then(res=>{
                state.totalSale=res.data.totalSale
                state.totalBuy=res.data.totalBuy
                return res
            })
        },
        storeClientProduct(_,payload){
            return request.post('/clients/products',payload)
        },
        deleteClientProduct(_,id){
            return request.delete(`/clients/products/${id}`)
        },
        updateClientProduct(_,payload){
            const {id,...payloadd}=payload
            return request.put(`/clients/products/${id}`,payloadd)
        },
        toPdf(_,payload){
            const {id,...payloadd}=payload;
            return request.get('/clients/products/pdf/'+id,{
                params:payloadd,
                responseType: 'blob'
            }).then(res=>{
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            })
        }
    },
    mutations:{
    }
}